import React, { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, FormControlLabel, Checkbox, CircularProgress, InputAdornment, Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Pagination, STableLoader, FilterComponent, PageLoader, EmptyCollection, DeletePopUp } from '../../shared_elements';
import { AssetInfo } from "../components";
import { TechSpecsNav } from '../../elements'
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import AddIcon from '@material-ui/icons/Add';
import { globalGetService, globalPutService, globalPostService, globalDeleteService, globalExportService, globalLeaseGetService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import useAssetInfo from '../hooks/useAssetInfo';
import { assetTypeValues, backendDateFormat, displayDateFormat, displayDateFormatShort, fieldDateFormat } from "../../../constants";
import moment from "moment";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { getPermissionKey } from "..";
import { regexConstants } from "../../../constants/regEx";
import { downloadFileType, numberWithCommas } from "../../../utils";
import { Autocomplete } from "@material-ui/lab";
import ShopVisitCard from "../components/ShopVisitCard";
import { trackActivity } from "../../../utils/mixpanel";
import { Info, Visibility } from "@material-ui/icons";
import config from "../../../config";
import ReadMoreInline from "../../../shared/components/ReadMoreInline";
import { hanwahaInstance, regionalOneInstance, testLessor, titanAviInstance } from "../../../shared/components";

const useEventAutocompleteStyles = makeStyles(() => ({
    inputRoot: {
        flexWrap: 'nowrap',
    },
    chipLabel: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
}));

const shopVisitobj = {
    name: null,
    shop_visit_start_date: null,
    shop_visit_end_date: null,
    shop_visit_facility: '',
    tsn: null,
    csn: null,
    tso: null,
    cso: null,
    as_of_date: null,
    cost: null,
    facility_location: '',
    workscope_details: '',
}

const getShopVisitEventUrlType = (assetType) => assetTypeValues[assetType]?.urlType === 'lg' ? 'landing_gear' : assetTypeValues[assetType]?.urlType;
const ShopVisitHd = ({ params, showGroup }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }}><div style={{ width: '85px' }}>Action(s)</div></TableCell>
                {params.type === 'aircraft' ?
                    <TableCell>
                        <div style={{ width: '150px' }}>Assembly</div>
                    </TableCell> : null
                }
                <TableCell> <div style={{ width: '180px' }}>Shop Visit Event</div></TableCell>
                <TableCell>
                    <div style={{ width: '157px' }}>Shop Visit Start Date</div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '167px' }}>Shop Visit End Date</div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '150px' }}>Shop Visit Cost</div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '110px' }}>Shop Visit Facility</div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '120px' }}>Facility Location</div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '110px' }}>TSN at Shop Visit</div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '110px' }}>CSN at Shop Visit</div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '120px' }}>As of Date</div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '110px' }}>TSO</div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '110px' }}>CSO</div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '140px' }}>Reason for Shop Visit</div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '182px' }}>Shop Visit Workscope/Details</div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '170px' }}>Shop Visit Status</div>
                </TableCell>
            </TableRow>
        </TableHead>
    )
}
const ShopVisitList = ({ item, onView, onEdit, onDelete, params, setEdit, getDropdownData }) => {
    const [showMore, setShowMore] = useState({});
    const toggleDescription = (field) => {
        setShowMore({
            ...showMore,
            [field]: !showMore[field],
        });
    };
    const calculateWidth = (minWidth, maxWidth, content, minCount, maxCount) => {
        let width = 130;
        if (content?.length > minCount && content?.length <= maxCount) {
            width = Math.max(content.length * 10, minWidth);
        } else if (content?.length > maxCount) {
            width = maxWidth;
        }

        return `${width}px`;
    }
    return (
        <TableRow>
            <TableCell style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1, }}>
                <ul className="list-inline">
                        <li className="list-inline-item">
                            <Tooltip title='View' arrow><Visibility color="primary" fontSize="small" style={{ cursor: 'pointer' }} onClick={() => onView()} /></Tooltip>
                        </li>
                    {checkPermission('technical_specs', 'shop_visit', 'U') && item?.status?.value === 1 ?
                        <li className="list-inline-item">
                            <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" style={{ cursor: 'pointer' }} onClick={() => { setEdit(false); onEdit(); getDropdownData() }} /></Tooltip>
                        </li> : null}
                    {checkPermission('technical_specs', 'shop_visit', 'D') ?
                        <li className="list-inline-item">
                            <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" style={{ cursor: 'pointer' }} onClick={() => { setEdit(false); onDelete() }} /></Tooltip>
                        </li> : null
                    }
                </ul>
            </TableCell>
            {params.type === 'aircraft' ?
                <TableCell>{item?.major_assembly?.name}</TableCell> : null
            }
            <TableCell>
                {params.type === 'engine'
                    ? (item?.events || []).map((event, index) => (
                        <Chip key={event?.maintenance_program?.id || index} label={event?.maintenance_program?.name} size="small" style={{ fontSize: '12px', marginRight: '3px', marginBottom: '3px' }} />
                    ))
                    : item?.maintenance_check?.name}
            </TableCell>
            <TableCell>
                {moment(item?.shop_visit_start_date).isValid() ? moment(item.shop_visit_start_date).format(displayDateFormatShort) : '--'}
            </TableCell>
            <TableCell>{moment(item?.shop_visit_end_date).isValid() ? moment(item?.shop_visit_end_date).format(displayDateFormatShort) : '--'}</TableCell>
            <TableCell>
                <div style={{ width: calculateWidth('100', '142', item?.cost, '15', '') }}>{item?.cost ? `$${numberWithCommas(item.cost)}` : 0}</div>
            </TableCell>
           
            <TableCell>

                {item?.shop_visit_facility && item?.shop_visit_facility?.length > 30 ? (
                    <div style={{ width: calculateWidth('150', '230', item?.shop_visit_facility, '30', '') }} >
                        {showMore[item?.field] && showMore[item?.field] ? (
                            <span> {item?.shop_visit_facility}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  >  less </a>
                            </span>
                        ) : (
                            <span> {item.shop_visit_facility.substring(0, 25)}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  > ..more </a>
                            </span>
                        )}
                    </div>
                ) :
                    <div style={{ width: calculateWidth('150', '195', item.shop_visit_facility, '1', '25') }}>{item.shop_visit_facility || '--'}</div>
                }
            </TableCell>
            <TableCell>
                {item?.facility_location && item?.facility_location?.length > 30 ? (
                    <div style={{ width: calculateWidth('120', '200', item?.facility_location, '30', '') }}>
                        {showMore[item?.field] ? (
                            <span> {item?.facility_location}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  >  less </a>
                            </span>
                        ) : (
                            <span> {item.facility_location.substring(0, 25)}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  > ..more </a>
                            </span>
                        )}
                    </div>
                ) :
                    <div style={{ width: calculateWidth('120', '195', item?.facility_location, '25', '') }}>{item.facility_location || '--'}</div>
                }

            </TableCell>
            <TableCell><div style={{ width: calculateWidth('100', '', item?.tsn, '10', '') }}>{item?.tsn === 0 ? '0' : item?.tsn ? numberWithCommas((item?.tsn)?.toFixed(2)) : '--'}</div></TableCell>
            <TableCell><div style={{ width: calculateWidth('100', '', item?.csn, '10', '') }}>{item?.csn === 0 ? '0' : item?.csn ? numberWithCommas(item?.csn) : '--'}</div></TableCell>
            <TableCell>{moment(item?.as_of_date).isValid() ? moment(item.as_of_date).format(displayDateFormatShort) : '--'}</TableCell>
            <TableCell><div style={{ width: calculateWidth('100', '', item?.tso, '10', '') }}>{item?.tso === 0 ? '0' : item?.tso ? numberWithCommas((item?.tso)?.toFixed(2)) : '--'}</div></TableCell>
            <TableCell><div style={{ width: calculateWidth('100', '', item?.cso, '10', '') }}>{item?.cso === 0 ? '0' : item?.cso ? numberWithCommas(item?.cso) : '--'}</div></TableCell>
            <TableCell>  <ReadMoreInline text={item?.removal_reason} maxLength='30' /></TableCell>
            <TableCell>
                {item?.workscope_details && item?.workscope_details?.length > 30 ? (
                    <div style={{ width: calculateWidth('150', '230', item?.workscope_details, '30', '') }}>
                        {showMore[item?.field] ? (
                            <span> {item?.workscope_details}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  >  less </a>
                            </span>
                        ) : (
                            <span> {item?.workscope_details.substring(0, 25)}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  > ..more </a>
                            </span>
                        )}
                    </div>
                ) : <div style={{ width: calculateWidth('150', '230', item?.workscope_details, '1', '30') }}>{item?.workscope_details|| "--"}</div>}
            </TableCell>
            <TableCell>{item?.status?.label || '--'}</TableCell>
        </TableRow>
    )
}
const AddEditShopVisit = ({ addEditShopVisit, toggleModalFn, getResponseBack, params, assetInfoData, majorAssemblyInfo, }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const eventAutocompleteClasses = useEventAutocompleteStyles();
    const [isLoading, setLoading] = useState(false);
    const [shopVisit, setShopVisit] = useState({ ...addEditShopVisit.data });
    const [eventOptions, setEventOptions] = useState([]);
    const [llpEventOptions, setLlpEventOptions] = useState([]);
    const [isLlpLoading, setLlpLoading] = useState(false);
    const [isEventLoading, setEventLoading] = useState(false);
    const [error, setError] = useState({})
    const isViewMode = addEditShopVisit?.mode === 'view';
    const displayValue = (value) => isViewMode && value !== '' && value !== null && value !== undefined ? numberWithCommas(value) : value;
    const leaseURLEndPoint = config.api.leaseRevampNetworkInterface
    const selectedAssemblyId = shopVisit?.major_assembly?.id || shopVisit?.major_assembly?.asset_id || shopVisit?.major_assembly || null;
    const selectedAssembly = (Array.isArray(majorAssemblyInfo) ? majorAssemblyInfo.find((item) => item.id === selectedAssemblyId) : null) || (shopVisit?.major_assembly?.asset_id ? shopVisit.major_assembly : null);
    const currentAssetType = assetInfoData?.asset_type?.type || null;
    const eventAssetType = params.type === 'aircraft' ? selectedAssembly?.asset_type : currentAssetType;
    const eventAssetId = params.type === 'aircraft' ? selectedAssemblyId : assetInfoData?.id;
    const selectedAssemblySlug = selectedAssembly?.slug || null;
    const isEngineContext = params.type === 'engine' || selectedAssembly?.asset_type === 2;
    const llpAssetSlug = params.type === 'engine' ? params.aircraft_slug : selectedAssemblySlug;
    const engineEvents = isEngineContext ? (shopVisit?.events || []) : [];
    // Same as LM buildEditShopVisit: saved events carry maintenance_program, newly selected ones fall back to eventOptions
    const isEngineEventLlp = (ev) => {
        if (typeof ev?.maintenance_program?.is_llp_event === 'boolean') return ev.maintenance_program.is_llp_event;
        const opt = eventOptions.find((o) => o.event_id === ev?.maintenance_program_id);
        return opt ? opt.is_llp_event : Boolean(ev?.modules?.length);
    };
    const selectedEngineEvents = engineEvents.map((ev) => {
        const event_id = ev?.maintenance_program_id ?? ev?.maintenance_program?.id;
        const opt = eventOptions.find((o) => o.event_id === event_id);
        return {
            event_id,
            event_name: ev?.maintenance_program?.name || opt?.event_name || '',
            is_llp_event: isEngineEventLlp(ev),
        };
    });
    const nonLlpEngineEvent = engineEvents.find((ev) => isEngineEventLlp(ev) === false);
    const isLlpOptionChecked = (option) => Boolean(nonLlpEngineEvent?.modules?.some((m) => m?.module_name === option?.label && m?.is_non_llp === !option?.isLlp));
    const isEngineNonLlpEventSelected = Boolean(isEngineContext && !!nonLlpEngineEvent);
    const isEngineLlpSectionVisible = Boolean(isEngineContext && llpAssetSlug && isEngineNonLlpEventSelected && shopVisit?.prsv);
    //Events API 
    useEffect(() => {
        if (!eventAssetId || !eventAssetType) {
            setEventOptions([]);
            return;
        }
        let active = true;
        setEventLoading(true);
        globalGetService(`config-data/asset-sv-events/${getShopVisitEventUrlType(eventAssetType)}/${eventAssetId}/?add_sv_dropdown=True`)
            .then(response => {
                if (!active) return;
                if (checkApiStatus(response)) {
                    if (isEngineContext) {
                        const events = response?.data?.data || [];
                        setEventOptions(events.map((item) => ({ event_name: item?.name, event_id: item?.id, is_llp_event: Boolean(item?.is_llp_event) })));
                    } else {
                        setEventOptions((response?.data?.data || []).map((item) => ({ event_name: item?.name, event_id: item?.id, })));
                    }
                }
                setEventLoading(false);
            });
        return () => {
            active = false;
        };
    }, [eventAssetId, eventAssetType, isEngineContext]);

    //LLP Api
    useEffect(() => {
        if (!isEngineLlpSectionVisible) {
            setLlpLoading(false);
            setLlpEventOptions([]);
            return;
        }
        let active = true;
        setLlpLoading(true);
        globalLeaseGetService(`${leaseURLEndPoint}/console/asset/engine/${llpAssetSlug}/llp/?for_reserve_account=module&is_llp_replacement=true&with_id=true`)
            .then(response => {
                if (!active) return;
                if (checkApiStatus(response)) {
                    const { llp = [], non_llp = [] } = response?.data?.data || {};
                    const options = [
                        ...llp.map(llps => ({ label: llps?.name, value: `${llps?.name?.toLowerCase()}_event`, isLlp: true, id: llps?.id })),
                        ...non_llp.map(nonLlps => ({ label: nonLlps?.name, value: `${nonLlps?.name?.toLowerCase()}_event`, isLlp: false, id: nonLlps?.id })),
                    ];
                    setLlpEventOptions(options);
                }
                setLlpLoading(false);
            })

        return () => {
            active = false;
        };
    }, [isEngineLlpSectionVisible, leaseURLEndPoint, llpAssetSlug]);

    const onAddEditShopVisit = () => {
        let validationInputs = {
            // workscope_details: shopVisit?.workscope_details?.length > 0 ? '' : 'Please enter Shop Visit WorkScope/Details',
            // cost: shopVisit.cost?.toString()?.trim().length >= 0 ? '' : 'Please enter Shop Visit Cost',
            major_assembly: params.type === 'aircraft' ? (selectedAssemblyId ? '' : 'Please select Assembly') : '',
            maintenance_check_id: isEngineContext ? (selectedEngineEvents.length > 0 ? '' : 'Please select Maintenance Event') : (shopVisit?.event_id || shopVisit?.maintenance_check_id || shopVisit?.maintenance_check?.id ? '' : 'Please select Maintenance Event'),
            tsn: !titanAviInstance && (!shopVisit?.tsn || !shopVisit.tsn.toString().trim()) ? 'Please enter TSN at Shop Visit' : '',
            csn: !titanAviInstance && (!shopVisit?.csn || !shopVisit.csn.toString().trim()) ? 'Please enter CSN at Shop Visit' : '',
            shop_visit_start_date: ['apu', 'lg', 'propeller', 'aircraft'].includes(params?.type) ? (moment(shopVisit?.shop_visit_start_date).isValid() ? moment(shopVisit.shop_visit_start_date).isSameOrAfter(assetInfoData?.date_of_manufacture) ? '' : "Shop Visit Start Date can't be lesser than Date of Manufacture" : '') : (shopVisit?.shop_visit_start_date ? moment(shopVisit.shop_visit_start_date).isSameOrAfter(assetInfoData?.manufacturing_date) ? '' : "Shop Visit Start Date can't be Lesser than Date of Manufacture" : ''),
            shop_visit_end_date: ['apu', 'lg', 'propeller', 'aircraft'].includes(params?.type) ? (shopVisit?.shop_visit_end_date ? moment(shopVisit.shop_visit_end_date).isSameOrAfter(assetInfoData?.date_of_manufacture) ? '' : "Shop Visit End Date can't be lesser than Date of Manufacture" : 'Please enter Shop Visit End Date') : (shopVisit?.shop_visit_end_date ? moment(shopVisit.shop_visit_end_date).isSameOrAfter(assetInfoData?.manufacturing_date) ? '' : "Shop Visit End Date can't be Lesser than Date of Manufacture" : 'Please enter Shop Visit End Date'),
            removal_reason:  shopVisit?.removal_reason?.length > 0 ? '' : 'Please enter Reason for Shop Visit',
            
        }
        if (shopVisit?.shop_visit_start_date && shopVisit?.shop_visit_end_date) {
            validationInputs = {
                ...validationInputs,
                shop_visit_end_date:  (moment(shopVisit?.shop_visit_end_date).isAfter(shopVisit?.shop_visit_start_date)) ? '' : "Shop Visit End Date can't be lesser than Shop Visit Start Date",
            }
        }
        if (shopVisit?.shop_visit_start_date && !moment(shopVisit?.shop_visit_start_date).isValid() ) {
            validationInputs = {
                ...validationInputs,
                shop_visit_start_date: 'Please enter valid Shop Visit Start Date'
            }
        }
        if (shopVisit?.shop_visit_end_date && !moment(shopVisit?.shop_visit_end_date).isValid() ) {
            validationInputs = {
                ...validationInputs,
                shop_visit_end_date: 'Please enter valid Shop Visit End Date'
            }
        }
        if (shopVisit?.as_of_date && !moment(shopVisit?.as_of_date).isValid() ) {
            validationInputs = {
                ...validationInputs,
                as_of_date: 'Please enter valid As of Date'
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            // if (!shopVisit?.prsv && !shopVisit?.llp_replacement && (params.type === 'engine'||selectedAssembly?.asset_type === 2) ) {
            //     enqueueSnackbar('Please select either PRSV Event or LLP Replacement.', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
            //     return
            // }
            setLoading(true)
            let payload = Object.assign({}, shopVisit)
            payload = {
                ...payload,
                major_assembly: params.type === 'aircraft' ? shopVisit?.major_assembly : payload?.major_assembly,
                ...(isEngineContext
                    ? { maintenance_check_id: null, events: engineEvents.map((ev) => ({ maintenance_program_id: ev.maintenance_program_id, cost: ev.cost || 0, modules: ev.modules || [] })) }
                    : { maintenance_check_id: shopVisit?.event_id || shopVisit?.maintenance_check_id || shopVisit?.maintenance_check?.id || null }
                ),
                prsv: shopVisit?.prsv,
                cost: shopVisit.cost ? shopVisit.cost : 0,
                csn: shopVisit.csn === 0 ? '0' : shopVisit.csn ? shopVisit.csn : null,
                tsn: shopVisit.tsn === 0 ? '0' : shopVisit.tsn ? shopVisit.tsn : null,
                cso: shopVisit.cso === 0 ? '0' : shopVisit.cso ? shopVisit.cso : null,
                tso: shopVisit.tso === 0 ? '0' : shopVisit.tso ? shopVisit.tso : null,
                as_of_date: shopVisit.as_of_date || null,
                asset_type: (params.type === 'aircraft' ? selectedAssembly?.asset_type : currentAssetType) || null,
                asset_id: (params.type === 'aircraft' ? selectedAssemblyId : assetInfoData?.id) || null,
                ...(params.type !== 'aircraft' ? { is_stand_alone: assetInfoData.msn ? false : true } : {})
            }
            if (isEngineContext) {
                delete payload.fan_event;
                delete payload.hpc_event;
                delete payload.hpt_event;
                delete payload.lpt_event;
                delete payload.non_llp_events;
                delete payload.other_events;
                delete payload.maintenance_events;
                delete payload.maintenance_check_ids;
                delete payload.maintenance_check;
            }
            if (shopVisit.id) {
                globalPutService(`${leaseURLEndPoint}/lease/shop-visit/${shopVisit.slug}/`, payload)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar('Shop Visit Updated Sucessfully', { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                            trackActivity('Console Management', { page_title: 'ShopVisit', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited ShopVisit data from Edit ShopVisit form' });
                            toggleModalFn(); getResponseBack();
                        }
                        setLoading(false)
                    })
            } else {
                globalPostService(`${leaseURLEndPoint}/lease/shop-visit/asset/${params.aircraft_slug}/`, payload)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar('Shop Visit Created Sucessfully', { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                            trackActivity('Console Management', { page_title: 'ShopVisit', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Added', event_desc: 'Added ShopVisit data from Add ShopVisit form' });
                            toggleModalFn(); getResponseBack();
                        }
                        setLoading(false)
                    })
            }
        } else {
            setError(validationInputs)
        }
    }
    const onFieldChange = (key, value) => {
        setShopVisit({ ...shopVisit, [key]: value });
    }
    const onCheckBoxChange = (option, checked) => {
        setShopVisit((prev) => {
            const events = [...(prev?.events || [])];
            const idx = events.findIndex((ev) => ev.maintenance_program_id === nonLlpEngineEvent?.maintenance_program_id);
            if (idx === -1) return prev;
            const modules = events[idx].modules || [];
            const matches = (m) => m?.module_name === option?.label && m?.is_non_llp === !option?.isLlp;
            const newModules = checked
                ? [...modules.filter((m) => !matches(m)), { limited_life_part_id: option?.id ?? null, module_name: option?.label, is_non_llp: !option?.isLlp, cost: 0 }]
                : modules.filter((m) => !matches(m));
            events[idx] = { ...events[idx], modules: newModules };
            return { ...prev, events };
        });
    }
    return (
        <Dialog open={addEditShopVisit.modal} onClose={toggleModalFn} className='console-management-modal' maxWidth="md" >
            <DialogTitle id="scroll-dialog-title">
                {isViewMode ? 'View ' : shopVisit?.id ? 'Edit ' : 'Add '} Shop Visit
            </DialogTitle>
            <DialogContent dividers={true}>
                <div>
                    <Grid container spacing={1}>
                        {params.type === 'aircraft' ? <>
                            <Grid item md={4}>
                                {(() => {
                                    return (
                                        <Autocomplete
                                            disabled={isViewMode || (shopVisit.id ? true : false)}
                                            disableClearable
                                            options={majorAssemblyInfo}
                                            getOptionLabel={(option) => option?.major_assembly_name || option?.name || ''}
                                            name="major_assembly"
                                            value={selectedAssembly}
                                            onChange={(e, value) => {
                                                setShopVisit({
                                                    ...shopVisit,
                                                    major_assembly: value,
                                                    event_id: null,
                                                    maintenance_check:null,
                                                    maintenance_check_id:null,
                                                    llp_replacement: value?.asset_type === 2 ? shopVisit?.llp_replacement || false : false,
                                                    events: [],
                                                });
                                                setError({ ...error, major_assembly: '' });
                                            }}
                                            renderInput={params =>
                                                <TextField
                                                    required
                                                    {...params}
                                                    label="Select Assembly"
                                                    margin="normal"
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    variant='outlined'
                                                    error={error?.major_assembly ? true : false}
                                                    helperText={error?.major_assembly || ''}
                                                />}
                                        />
                                    )
                                })()}
                            </Grid></> : null
                        }
                        <Grid item md={4}>
                            {(() => {
                                if (isEngineContext) {
                                    return (
                                        <Autocomplete
                                            multiple
                                            classes={eventAutocompleteClasses}
                                            disabled={isViewMode}
                                            loading={isEventLoading}
                                            options={eventOptions}
                                            getOptionLabel={(option) => option?.event_name || ''}
                                            getOptionSelected={(option, value) => option?.event_id === value?.event_id}
                                            getOptionDisabled={(option) => {
                                                if (selectedEngineEvents.some((sel) => sel?.event_id === option?.event_id)) return false;
                                                return selectedEngineEvents.some((sel) => sel?.is_llp_event === option?.is_llp_event);
                                            }}
                                            name="maintenance_events"
                                            value={selectedEngineEvents}
                                            onChange={(e, values) => {
                                                const lastNonLlp = [...values].reverse().find((item) => item?.is_llp_event === false);
                                                const lastLlp = [...values].reverse().find((item) => item?.is_llp_event === true);
                                                const newSelection = [lastNonLlp, lastLlp].filter(Boolean);
                                                const newEvents = newSelection.map((sel) => engineEvents.find((ev) => ev.maintenance_program_id === sel.event_id) || { maintenance_program_id: sel.event_id, cost: 0, modules: [] });
                                                setShopVisit({
                                                    ...shopVisit,
                                                    events: newEvents,
                                                    ...(lastNonLlp ? {} : { prsv: false }),
                                                });
                                                setError({ ...error, maintenance_check_id: '' });
                                            }}
                                            renderTags={(tagValue, getTagProps) => (
                                                <div style={{ display: 'flex', flexWrap: 'nowrap', overflow: 'hidden', width: '100%', gap: 4 }}>
                                                    {tagValue.map((option, index) => (
                                                        <Tooltip key={option?.event_key || option?.event_id || index} title={option?.event_name || ''}>
                                                            <span style={{ minWidth: 0, flex: '1 1 0', display: 'inline-block' }}>
                                                            <Chip
                                                                label={option?.event_name}
                                                                size="small"
                                                                disabled={isViewMode}
                                                                style={{ minWidth: 0, width: '100%' }}
                                                                classes={{ label: eventAutocompleteClasses.chipLabel }}
                                                                {...getTagProps({ index })}
                                                            />
                                                            </span>
                                                        </Tooltip>
                                                    ))}
                                                </div>
                                            )}
                                            renderInput={params =>
                                                <TextField
                                                    required
                                                    {...params}
                                                    label="Select Maintenance Event"
                                                    margin="normal"
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                    variant='outlined'
                                                    error={error?.maintenance_check_id ? true : false}
                                                    helperText={error?.maintenance_check_id || ''}
                                                />}
                                        />
                                    )
                                }
                                let optionValue = eventOptions?.length && (shopVisit?.event_id || shopVisit?.maintenance_check_id) ? eventOptions.find((optionItem) => optionItem.event_id === (shopVisit?.event_id || shopVisit?.maintenance_check_id)) : null
                                return (
                                    <Autocomplete
                                        disabled={isViewMode}
                                        disableClearable
                                        loading={isEventLoading}
                                        options={eventOptions}
                                        getOptionLabel={(option) => option?.event_name}
                                        name="event_id"
                                        value={optionValue || (shopVisit?.maintenance_check?.name ? { event_name: shopVisit?.maintenance_check?.name } : null)}
                                        onChange={(e, value) => { onFieldChange('event_id', value ? value.event_id : null); setError({ ...error, maintenance_check_id: '' }) }}
                                        renderInput={params =>
                                            <TextField
                                                required
                                                {...params}
                                                label="Select Maintenance Event"
                                                margin="normal"
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                variant='outlined'
                                                error={error?.maintenance_check_id ? true : false}
                                                helperText={error?.maintenance_check_id || ''}
                                            />}
                                    />
                                )
                            })()}
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                name='cost'
                                label='Shop Visit Cost(USD)'
                                value={displayValue(shopVisit?.cost || 0)}
                                fullWidth
                                inputProps={{ maxLength: 15 }}
                                margin="normal"
                                disabled={isViewMode}
                                onChange={(e) => regexConstants.numberWithDot.test(e.target.value) ? onFieldChange('cost', e.target.value) : e.preventDefault()}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">$</InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item md={4}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    name="shop_visit_start_date"
                                    label="Shop Visit Start Date"
                                    format={fieldDateFormat}
                                    fullWidth
                                    disabled={isViewMode}
                                    disableFuture
                                    InputLabelProps={{ shrink: true }}
                                    value={shopVisit?.shop_visit_start_date || null}
                                    onChange={(data, value) => { onFieldChange('shop_visit_start_date', data ? moment(data).format(backendDateFormat) : null); setError({ ...error, 'shop_visit_start_date': '' }) }}
                                    inputVariant='outlined'
                                    minDate={['apu', 'lg', 'propeller', 'aircraft'].includes(params?.type) ? (moment(assetInfoData?.date_of_manufacture)) : (moment(assetInfoData?.manufacturing_date))}
                                    error={error?.shop_visit_start_date ? true : false}
                                    helperText={error?.shop_visit_start_date || ''}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={4}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    required
                                    margin="normal"
                                    name="shop_visit_end_date"
                                    label="Shop Visit End Date"
                                    format={fieldDateFormat}
                                    fullWidth
                                    disabled={isViewMode}
                                    disableFuture
                                    InputLabelProps={{ shrink: true }}
                                    value={shopVisit?.shop_visit_end_date || null}
                                    onChange={(data, value) => { onFieldChange('shop_visit_end_date', data ? moment(data).format(backendDateFormat) : null); setError({ ...error, 'shop_visit_end_date': '' }) }}
                                    inputVariant='outlined'
                                    minDate={shopVisit.shop_visit_start_date ? moment(shopVisit?.shop_visit_start_date) : ['apu', 'lg', 'propeller', 'aircraft'].includes(params?.type) ? (moment(assetInfoData?.date_of_manufacture)) : (moment(assetInfoData?.manufacturing_date))}
                                    error={error?.shop_visit_end_date ? true : false}
                                    helperText={error?.shop_visit_end_date || ''}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                required={!titanAviInstance}
                                name='tsn'
                                label='TSN at Shop Visit'
                                value={shopVisit.tsn === null ? '' : shopVisit?.tsn === 0 ? '0' : shopVisit.tsn ? displayValue(shopVisit.tsn) : ''}
                                fullWidth
                                margin="normal"
                                disabled={isViewMode}
                                inputProps={{ maxLength: 10 }}
                                onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('tsn', e.target.value) : e.preventDefault()}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                error={error.tsn ? true : false}
                                onFocus={() => setError({ ...error, 'tsn': '' })}
                                helperText={error.tsn || ''}
                            />
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                required={!titanAviInstance}
                                name='csn'
                                label='CSN at Shop Visit'
                                value={shopVisit.csn === null ? '' : shopVisit?.csn === 0 ? '0' : shopVisit.csn ? displayValue(shopVisit.csn) : ''}
                                fullWidth
                                margin="normal"
                                disabled={isViewMode}
                                inputProps={{ maxLength: 10 }}
                                onChange={(e) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('csn', e.target.value) : e.preventDefault()}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                error={error?.csn ? true : false}
                                onFocus={() => setError({ ...error, 'csn': '' })}
                                helperText={error?.csn || ''}
                            />
                        </Grid>
                        {titanAviInstance && <>
                            <Grid item md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        name="as_of_date"
                                        label="As of Date"
                                        format={fieldDateFormat}
                                        fullWidth
                                        disabled={isViewMode}
                                        disableFuture
                                        InputLabelProps={{ shrink: true }}
                                        value={shopVisit?.as_of_date || null}
                                        onChange={(data, value) => { onFieldChange('as_of_date', data ? moment(data).format(backendDateFormat) : null); setError({ ...error, 'as_of_date': '' }) }}
                                        inputVariant='outlined'
                                        error={error?.as_of_date ? true : false}
                                        helperText={error?.as_of_date || ''}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={4}>
                                <TextField
                                    name='tso'
                                    label='TSO'
                                    value={shopVisit.tso === null ? '' : shopVisit?.tso === 0 ? '0' : shopVisit.tso ? displayValue(shopVisit.tso) : ''}
                                    fullWidth
                                    margin="normal"
                                    disabled={isViewMode}
                                    inputProps={{ maxLength: 10 }}
                                    onChange={(e) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('tso', e.target.value) : e.preventDefault()}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4}>
                                <TextField
                                    name='cso'
                                    label='CSO'
                                    value={shopVisit.cso === null ? '' : shopVisit?.cso === 0 ? '0' : shopVisit.cso ? displayValue(shopVisit.cso) : ''}
                                    fullWidth
                                    margin="normal"
                                    disabled={isViewMode}
                                    inputProps={{ maxLength: 10 }}
                                    onChange={(e) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('cso', e.target.value) : e.preventDefault()}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </>}
                        <Grid item md={12}>
                            <TextField
                                name='shop_visit_facility'
                                label='Shop Visit Facility'
                                value={shopVisit?.shop_visit_facility || ''}
                                fullWidth
                                multiline
                                margin="normal"
                                disabled={isViewMode}
                                onChange={(e) => onFieldChange('shop_visit_facility', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={12}>
                            <TextField
                                name='facility_location'
                                label='Facility Location'
                                value={shopVisit?.facility_location || ''}
                                fullWidth
                                margin="normal"
                                multiline
                                disabled={isViewMode}
                                onChange={(e) => onFieldChange('facility_location', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={12}>
                            <TextField
                                required
                                name='removal_reason'
                                label='Reason for Shop Visit'
                                value={shopVisit?.removal_reason || ''}
                                fullWidth
                                margin="normal"
                                multiline
                                disabled={isViewMode}
                                onChange={(e) => onFieldChange('removal_reason', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 250 }}
                                variant='outlined'
                                error={error.removal_reason ? true : false}
                                onFocus={() => setError({ ...error, 'removal_reason': '' })}
                                helperText={error.removal_reason || ''}
                            />
                        </Grid>
                        <Grid item md={12}>
                            <TextField
                                name='workscope_details'
                                label='Shop Visit Workscope/Details'
                                value={shopVisit?.workscope_details || ''}
                                fullWidth
                                margin="normal"
                                multiline
                                rows={4}
                                disabled={isViewMode}
                                onChange={(e) => onFieldChange('workscope_details', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ style: { overflow: "auto" }, maxLength: 255 }}
                                InputProps={{ style: { overflow: "auto" } }}   
                                variant='outlined'
                                error={error.workscope_details ? true : false}
                                onFocus={() => setError({ ...error, 'workscope_details': '' })}
                                helperText={error.workscope_details || ''}
                            />
                        </Grid>
                        {!isEngineContext &&
                            <Grid container item md={12} >
                                <Grid item md={6}>
                                    <FormControlLabel
                                        control={<Checkbox size="small" color="primary" disabled={isViewMode} checked={shopVisit?.prsv || false} onChange={(e) => onFieldChange('prsv', e.target.checked)} name="prsv" />}
                                        label={<p style={{ fontSize: '13px' }}>PRSV Event</p>}
                                    />
                                </Grid>
                            </Grid>
                        }
                        {isEngineContext && isEngineNonLlpEventSelected &&
                            <Grid container item md={12}>
                                <Grid item md={6}>
                                    <FormControlLabel
                                        control={<Checkbox size="small" color="primary" disabled={isViewMode} checked={shopVisit?.prsv || false} onChange={(e) => onFieldChange('prsv', e.target.checked)} name="prsv" />}
                                        label={<p style={{ fontSize: '13px' }}>PRSV Event</p>}
                                    />
                                </Grid>
                            </Grid>
                        }
                        {isEngineLlpSectionVisible ?
                            <Grid item md={12}>
                                <Paper variant="outlined" style={{ padding: '12px 16px', backgroundColor: '#fafafa' }}>
                                    <Grid container>
                                        {isLlpLoading ?
                                            <Grid item md={12}>
                                                <CircularProgress size={20} />
                                            </Grid> : null}
                                        {!isLlpLoading && llpEventOptions.map((option) => (
                                            <Grid item md={3} key={option?.value}>
                                                <FormControlLabel
                                                    control={<Checkbox size="small" color="primary" disabled={isViewMode} checked={isLlpOptionChecked(option)} onChange={(e) => onCheckBoxChange(option, e.target.checked)} name={option?.value} />}
                                                    label={
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', minWidth: 0 }}>
                                                            <Tooltip title={option?.label?.length > 20 ? option.label : ''} placement="top" arrow>
                                                                <span style={{ fontSize: '13px', maxWidth: '140px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block' }}>{option?.label}</span>
                                                            </Tooltip>
                                                            {!option?.isLlp && <Chip label="Non LLP" size="small" style={{ fontSize: '10px', height: '18px', flexShrink: 0 }} />}
                                                        </div>
                                                    }
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Paper>
                            </Grid> : null}
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading || isLlpLoading || isEventLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>{isViewMode ? 'Close' : 'Cancel'}</Button>
                {!isViewMode &&
                    <Button disabled={isLoading || isLlpLoading || isEventLoading} onClick={onAddEditShopVisit} color='primary' size='small' variant='contained'>
                        {isLoading ? <CircularProgress size={24} /> : 'Save'}
                    </Button>
                }
            </DialogActions>
        </Dialog>
    )
}
const getShopVisitTableOffset = (hasList, isEdit, hasLessorInstance,hanwahaInstance) => {
    if (hasList) {
        if (isEdit) return !hasLessorInstance ?  440 : (hanwahaInstance ? 495 :515) ;
        return !hasLessorInstance ? 400 : (hanwahaInstance ? 475 :455) ;
    }
    if (isEdit) return !hasLessorInstance ? 460 : (hanwahaInstance ? 440 :390);
    return !hasLessorInstance ? 340 : (hanwahaInstance ? 420 : 400) ;
}

const ShopVisitsV2 = ({ params }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [shopVisitsInfo, setShopVisitsInfo] = useState({ list: [], pagination: {} });
    const [addEditShopVisit, setAddEditShopVisit] = useState({ modal: false, data: null });
    const [deleteShopVisit, setDeleteShopVisit] = useState({ modal: false, data: null });
    const { assetInfoData, assetSkeletonLoader, refreshAssetInfo } = useAssetInfo(params.type, params.aircraft_slug);
    const [shopvisit, setShopvisit] = useState()
    const [isEdit, setEdit] = useState(false);
    const [majorAssemblyInfo, setMajorAssemblyInfo] = useState([])
    const leaseURLEndPoint = config.api.leaseRevampNetworkInterface
    useEffect(() => {
        getShopVisits({per_page:50}, 'skeletonLoader');
        if (['apu', 'lg', 'propeller', 'engine', 'aircraft'].includes(params.type)) {
            shopVistInfo({}, 'skeletonLoader');
        }
    }, []);
    const getDropdownData = () => {
        if (params.type === 'aircraft') {
            getMajorAssemblies()
        }
    }
    const getShopVisits = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalLeaseGetService(`${leaseURLEndPoint}/lease/v2/shop-visit/asset-type/${params.type === 'lg' ? 'landing_gear' : params.type}/asset/${params.aircraft_slug}/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setShopVisitsInfo(response.data.data)
                    if (['apu', 'lg', 'propeller', 'engine', 'aircraft'].includes(params.type)) {
                        shopVistInfo()
                    }
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onDeleteShopVisit = () => {
        setLoading(true);
        globalDeleteService(`${leaseURLEndPoint}/lease/shop-visit/asset/${deleteShopVisit?.data?.slug}/`, { ids: [deleteShopVisit?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteShopVisit({ modal: false, data: null })
                    enqueueSnackbar('Shop Visit Deleted Sucessfully', { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                    getShopVisits({per_page: shopVisitsInfo?.pagination?.per_page}, 'pageLoader');
                }
                // setLoading(false);
            })
    }
    const shopVistInfo = (loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalLeaseGetService(`${leaseURLEndPoint}/lease/${params.type}/${params.aircraft_slug}/shop-visit-card/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setShopvisit(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onExportShopVist = () => {
        setLoading(true);
        globalExportService(`${leaseURLEndPoint}/lease/v2/shop-visit/asset-type/${params.type}/asset/${params.aircraft_slug}/`)
            .then(response => {
                downloadFileType(response, `${assetTypeValues[assetInfoData?.asset_type.type].label} ${assetInfoData.serial_number} shop_visit ${moment().format(fieldDateFormat)}`, 'xlsx')
                trackActivity('Console Management', { page_title: ' ShopVisit', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Exported', event_desc: 'Shop Visit Exported Successfully', file_extension: 'xlsx' });
                // enqueueSnackbar("Incedent-Aog Exported Successully", { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                setLoading(false);
            })
    }
    const getMajorAssemblies = (data) => {
        setLoading(true);
        globalGetService(`console/v2/aircraft/${params.aircraft_slug}/major-assemblies/?include_asset=true&include_msn=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setMajorAssemblyInfo(response.data.data.list);
                }
                setLoading(false);
            })
    }
    const onFieldChange = (key, value) => {
        setShopvisit({ ...shopvisit, [key]: value })
    }
    const SVCARDINSTANCEHEIGHT = (hanwahaInstance || regionalOneInstance || titanAviInstance || testLessor)
    console.log("SVCARDINSTANCEHEIGHT",!SVCARDINSTANCEHEIGHT ? "YES" : "No")
    return (
        <section className="asset-tech-specs">
            <AssetInfo assetInfoData={assetInfoData} skeletonLoader={assetSkeletonLoader} getResponseBack={refreshAssetInfo} />
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 162}px` }}>
                <TechSpecsNav />
                <div className="tech-specs-content">
                    <div style={{ padding: '0px 10px' }}>
                        {skeletonLoader ? <STableLoader count={8} /> :
                            <>
                                {['apu', 'lg', 'propeller', 'engine', 'aircraft'].includes(params?.type) ?
                                    <div style={{ padding: '3px' }}>
                                        <ShopVisitCard assetInfoData={assetInfoData} onFieldChange={onFieldChange} isEdit={isEdit} setEdit={setEdit} shopVistInfo={shopVistInfo} shopvisit={shopvisit} setShopVisit={setShopvisit} />
                                    </div> : null}
                                <div style={{ padding: '3px' }}>
                                    <Paper elevation={0} className="console-paper" style={{ padding: '5px 10px' }}>
                                        <Grid container spacing={1} alignItems="center">
                                            <Grid item md={9}></Grid>
                                            <Grid item md={3}>
                                                <ul className="list-inline flex-centered" style={{ float: 'right' }}>
                                                    {checkPermission('technical_specs', 'shop_visit', 'C') ?
                                                        <li className="list-inline-item">
                                                            <Button onClick={() => { setEdit(false); getDropdownData(); setAddEditShopVisit({ modal: true, mode: 'add', data: shopVisitobj }) }} color='primary' size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />Add</Button>
                                                        </li> : null}
                                                    {/* {shopVisitsInfo?.list?.length && checkPermission('technical_specs', 'shop_visit', 'EXP') ?
                                                        <li className="list-inline-item">
                                                            <Button onClick={() => { setEdit(false); onExportShopVist() }} color='primary' size='small' variant="outlined">Export</Button>
                                                        </li> : null} */}
                                                </ul>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                    <Paper square>
                                       <div style={{height:`${window.innerHeight - getShopVisitTableOffset(shopVisitsInfo?.list?.length, isEdit, SVCARDINSTANCEHEIGHT,hanwahaInstance)}px`,overflow:'auto',marginTop: "3px"}}>
                                        <Table className='mui-table-format' stickyHeader>
                                            <ShopVisitHd showGroup={shopVisitsInfo?.list?.filter(item => item?.is_grouped)?.length} params={params} />
                                            <TableBody>
                                                {shopVisitsInfo && shopVisitsInfo?.list?.map((item, index) =>
                                                    <ShopVisitList
                                                        showGroup={shopVisitsInfo?.list?.filter(item => item?.is_grouped)?.length}
                                                        key={index}
                                                        item={item}
                                                        onView={() => setAddEditShopVisit({ modal: true, mode: 'view', data: item })}
                                                        onEdit={() => setAddEditShopVisit({ modal: true, mode: 'edit', data: item })}
                                                        onDelete={() => setDeleteShopVisit({ modal: true, data: item })}
                                                        params={params}
                                                        setEdit={setEdit}
                                                        leaseURLEndPoint={leaseURLEndPoint}
                                                        getDropdownData = {()=>getDropdownData()}
                                                    />
                                                )}
                                            </TableBody>
                                        </Table>
                                        {!shopVisitsInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                        </div>
                                    </Paper>
                                    <Paper square>
                                        <Pagination
                                            pagination={shopVisitsInfo.pagination}
                                            onChangePage={(event, newPage) => getShopVisits({ ...filter, page: newPage + 1, per_page: shopVisitsInfo.pagination.per_page }, 'pageLoader')}
                                            onChangeRowsPerPage={(event) => getShopVisits({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                                        />
                                    </Paper>
                                </div>
                            </>
                        }
                        {addEditShopVisit.modal ?
                            <AddEditShopVisit
                                majorAssemblyInfo={majorAssemblyInfo}
                                addEditShopVisit={addEditShopVisit}
                                toggleModalFn={() => setAddEditShopVisit({ modal: false, data: null })}
                                getResponseBack={() => getShopVisits({per_page: shopVisitsInfo?.pagination?.per_page}, 'pageLoader')}
                                params={params}
                                assetInfoData={assetInfoData}
                            /> : null
                        }
                        {deleteShopVisit.modal ?
                            <DeletePopUp
                                modal={deleteShopVisit.modal}
                                title='Delete Shop Visit'
                                content={`Are you sure, you want to Delete?`}
                                toggleModalFn={() => setDeleteShopVisit({ modal: false, data: null })}
                                deleteRecordFn={onDeleteShopVisit}
                            /> : null
                        }
                        {isLoading ? <PageLoader /> : null}
                    </div>
                </div>
            </Paper>
        </section>

    )
}
export default ShopVisitsV2;
